import { render } from "./UploadProfileImage.vue?vue&type=template&id=4718fc13&scoped=true"
import script from "./UploadProfileImage.vue?vue&type=script&lang=js"
export * from "./UploadProfileImage.vue?vue&type=script&lang=js"

import "./UploadProfileImage.vue?vue&type=style&index=0&id=4718fc13&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4718fc13"]])

export default __exports__